import React, { forwardRef, useImperativeHandle, useRef } from "react";
import Popup, { PopupActions } from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./dropdownPopup.scss";

export interface DropdownPopupProps {
  opened?: boolean;
  triggerElement?: JSX.Element | ((isOpen: boolean) => JSX.Element);
  onClose?: () => void;
  onOpen?: () => void;
  className?: string;
  position?: any;
  contentStyle?: any;
  /** When true, popup is uncontrolled (manages its own open state). Trigger handles toggle. */
  uncontrolled?: boolean;
}

export interface DropdownPopupRef {
  close: () => void;
  open: () => void;
  toggle: () => void;
}

const DropdownPopup = forwardRef<DropdownPopupRef, DropdownPopupProps>((props, ref) => {
  const popupRef = useRef<PopupActions>(null);
  const position: any = props.position ? props.position : "bottom left";

  useImperativeHandle(ref, () => ({
    close: () => popupRef.current?.close(),
    open: () => popupRef.current?.open(),
    toggle: () => popupRef.current?.toggle(),
  }));

  const isControlled = props.opened !== undefined && !props.uncontrolled;

  return (
    <Popup
      ref={popupRef}
      className={props.className}
      trigger={props.triggerElement ?? <div></div>}
      open={isControlled ? props.opened : undefined}
      defaultOpen={false}
      position={position}
      closeOnDocumentClick
      closeOnEscape
      onClose={props.onClose}
      onOpen={props.onOpen}
      arrow={false}
      offsetY={10}
      contentStyle={props.contentStyle || {
        borderRadius: 4,
        border: "1px solid #E0E0E0",
        boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.15)",
        padding: "16px 24px",
        zIndex: 22
      }}
      overlayStyle={{
        zIndex: 21,
        backgroundColor: "#efefef",
        opacity: "10%",
      }}
    >
      <div>{props.children}</div>
    </Popup>
  );
});

DropdownPopup.displayName = "DropdownPopup";

export default DropdownPopup;
